import { QueryFactory } from "../../../../Common";
export const QGetEventsByEventId = QueryFactory("GetEventsByEventId");
//# sourceMappingURL=QGetEventsByEventId.js.map